module.exports = __webpack_public_path__ + "img/sq4d_02.16cfaa57.jpg";